import { BasicAuthServiceHelper } from '@/modules/Auth'
import { Review } from '@/dataV3/Review/Review'
import { PostReview, PostInternalReview, PostExternalReview, GetReviews, AskReview, AnswerReview } from './apiTypes'
import { IRI } from 'emt-library'

/* *******************************
  POST REVIEW
******************************* */

export const postReviewAsync = async (reviewIRI: IRI, body: PostReview.Body): Promise<Review> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<PostReview.Response, PostReview.Body>(
    PostReview.Route(reviewIRI),
    { body },
  )
}

export const postInternalReview = async (body: PostInternalReview.Body): Promise<Review> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<PostInternalReview.Response, PostInternalReview.Body>(
    PostInternalReview.Route(),
    { body },
  )
}

export const postExternalReview = async (body: PostExternalReview.Body): Promise<Review> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<PostExternalReview.Response, PostExternalReview.Body>(
    PostExternalReview.Route(),
    { body },
  )
}

/* *******************************
  GET REVIEWS
******************************* */

export const getReviews = async (targetId: string, params: GetReviews.UrlParams): Promise<GetReviews.Response> => {
  const query = new URLSearchParams({
    page: params.page.toString(),
    perPage: params.perPage.toString(),
    sortBy: params.sortBy,
    direction: params.direction,
  }).toString()
  const path = `/v3/target/${targetId}/reviews?${query}`
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<GetReviews.Response>({ method: 'GET', path })
}

/* *******************************
  ASK REVIEWS
******************************* */

export const askReviews = async (body: AskReview.Body): Promise<AskReview.Response> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<AskReview.Response, AskReview.Body>(
    AskReview.Route(),
    { body },
  )
}

/* *******************************
  ANSWER REVIEW
******************************* */

export const answerReview = async (reviewId: string, body: AnswerReview.Body): Promise<AnswerReview.Response> => {
  return await BasicAuthServiceHelper.requestAuthenticatedV2Async<AnswerReview.Response, AnswerReview.Body>(
    { ...AnswerReview.Route(), path: `/v3/reviews/${reviewId}/answer` },
    { body },
  )
}
